import classes from './style.module.scss';
import { ClearInputIcon } from '../../common/components/icons';
import { Flex } from 'antd';
import { spacing } from '../../theming';

const ShortcutText = ({ shortcut }) => {
    return <span className={classes.shortcutHint}>{shortcut}</span>;
};

export const Suffix = ({ search, setSearch, handleSearchChange }) => {
    const isMac = navigator.userAgentData?.platform === 'macOS';
    const shortcut = isMac ? '⌘ + F' : 'Ctrl + F';

    if (search) {
        return (
            <Flex align="center" gap={spacing[1]}>
                <ShortcutText shortcut="Esc" />
                <ClearInputIcon setSearchText={setSearch} handleReset={() => handleSearchChange('')} />
            </Flex>
        );
    }

    return <ShortcutText shortcut={shortcut} />;
};

export const searchKeyHandler =
    ({ searchInputRef, handleSearchChange }) =>
    e => {
        const { key, metaKey, ctrlKey } = e;

        if (key.toLowerCase() === 'f' && (metaKey || ctrlKey) && searchInputRef.current) {
            e.preventDefault();
            searchInputRef.current.focus();
            searchInputRef.current.select();
            return;
        }

        if (key === 'Escape' && searchInputRef.current) {
            searchInputRef.current.blur();
            handleSearchChange('');
        }
    };
